import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { TextInput } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import { format } from '../../../../models/format'
import { validateSwedishLegalGovernmentId } from '../../../../util/organisationIdUtils'
import { Countries } from '../../../../models/countries'

const OrganisationIdInput = ({
  countryCode,
  orgId,
  updateOrgId,
  disabled,
  orgIdValid,
}) => {
  const [rawValue, setRawValue] = useState(orgId)
  const [trimmedValue, setTrimmedValue] = useState(orgId)

  useEffect(() => {
    const trimmedOrgId = (rawValue || '').trim()
    updateOrgId(trimmedOrgId)
    setTrimmedValue(trimmedOrgId)
  }, [rawValue])

  return (
    <TextInput
      id="organisation-id"
      format={format.orgNrWithWhitespace[countryCode]}
      placeholder={getText('payApply.applicant.legal.placeholder')}
      value={rawValue}
      required={getText('payApply.applicant.required')}
      onChange={e => setRawValue(e.target.value)}
      disabled={disabled}
      isValid={validation => {
        if (countryCode === Countries.SE) {
          orgIdValid({
            valid:
              trimmedValue && validateSwedishLegalGovernmentId(trimmedValue),
          })
        } else {
          orgIdValid(validation)
        }
      }}
      disableAutocomplete
      autoFocus
    />
  )
}

OrganisationIdInput.propTypes = {
  countryCode: PropTypes.string.isRequired,
  orgId: PropTypes.string,
  disabled: PropTypes.bool,
  updateOrgId: PropTypes.func.isRequired,
  orgIdValid: PropTypes.func.isRequired,
}

OrganisationIdInput.defaultProps = {
  orgId: '',
  disabled: false,
}

export default OrganisationIdInput
